import { Component, OnInit } from '@angular/core';
import { SeoService } from '../../../core/services/seoService/seo.service';
import {HttpClient} from "@angular/common/http";
import {FormControl, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {

  constructor(private seo: SeoService, private http: HttpClient) { }

  formBody = new FormBody();
  formResult = {};
  submitting = false;
  success = false;

  contactForm: any;

  ngOnInit() {
    this.seo.generateTags({
      title: 'Contact Us',
      description: 'Kopa Kilimanjaro contact page. Call us now for questions on which trip is best for you and your family!',
      slug: 'contact-us'
    });

    this.contactForm = new FormGroup({
      firstName: new FormControl(this.formBody.firstName, Validators.required),
      lastName: new FormControl(this.formBody.lastName, Validators.required),
      email: new FormControl(this.formBody.email, [Validators.required, Validators.email]),
      message: new FormControl(this.formBody.message, Validators.required),
      optIn: new FormControl(this.formBody.optIn)
    });
  }

  isMobile() {
    return document.body.clientWidth < 992;
  }

  isFormFilled() {
    return !this.contactForm.invalid;
  }

  submitForm() {
    this.submitting = true;
    if(!this.success) {
      this.formResult["firstName"] = this.contactForm.value.firstName;
      this.formResult["lastName"] = this.contactForm.value.lastName;
      this.formResult["email"] = this.contactForm.value.email;
      this.formResult["message"] = this.contactForm.value.message;
      this.formResult['optIn'] = this.contactForm.value.optIn;

      const serializedForm = JSON.stringify(this.formResult);
      this.http.post("https://uzmwaxt0ih.execute-api.us-east-1.amazonaws.com/contactUsSubmit", serializedForm)
        .subscribe(
          data => {
            this.submitting = false;
            this.success = true;
          },
          error => {
            this.submitting = false;
          }
        );
      return false;
    }
  }
}

export class FormBody {
  firstName: string;
  lastName: string;
  email: string;
  message: string;
  optIn: any;
}
